import type { ColorDeBadge } from '@/shared/components/Badge'

/**
 * El color de cada estatus que se repite en varias pantallas. Vive aquí para
 * que «Confirmada» sea el mismo verde en compras, en el portal del proveedor y
 * en RH, y no se redefina pantalla por pantalla.
 */

export const colorDeEstatusOrden = (status: string): ColorDeBadge => {
  const colores: Record<string, ColorDeBadge> = {
    draft: 'gris',
    pending: 'amarillo',
    confirmed: 'verde',
    rejected: 'rojo',
    in_progress: 'azul',
    completed: 'verde',
    cancelled: 'rojo',
  }
  return colores[status] ?? 'gris'
}

export const colorDeEstatusProveedor = (status: string): ColorDeBadge => {
  const colores: Record<string, ColorDeBadge> = {
    pre_registered: 'gris',
    sent_to_review: 'azul',
    pending: 'amarillo',
    approved: 'verde',
    rejected: 'rojo',
    active: 'verde',
    inactive: 'gris',
  }
  return colores[status] ?? 'gris'
}

export const colorDeEstatusFactura = (status?: string): ColorDeBadge => {
  switch (status) {
    case 'approved': return 'verde'
    case 'rejected': return 'rojo'
    case 'observed': return 'naranja'
    default: return 'azul'
  }
}
